import { Span } from "@vp/swan";
import React from "react";
import { IRangePrice } from "../../types/pricing";
import { formatPrice } from "./ComparativePrice";
import VatMessage from "./VatMessage";

interface LegacyRangePriceProps {
  pricingInfo: IRangePrice;
  /** @deprecated ignored; synchronous rendering */
  placeHolderText?: string;
  /** @deprecated use className instead */
  classNameWrapper?: string;
  className?: string;
  /** @deprecated not used */
  tenant?: string;
  /** When true, stacks the list-price range above the discount range (display: block) */
  splitInMultipleLines?: boolean;
}

const LegacyRangePrice: React.FC<LegacyRangePriceProps> = ({
  pricingInfo,
  classNameWrapper,
  className,
  splitInMultipleLines,
}) => {
  const wrapperClass = classNameWrapper || className;
  const {
    lowestListPrice,
    highestListPrice,
    lowestDiscountPrice,
    highestDiscountPrice,
    currency,
    culture,
    minimumFractionDigits,
    vatInc,
    hideVatMessage,
    hideShippingMessageInVatMessage,
  } = pricingInfo;

  const showComparison =
    lowestListPrice !== lowestDiscountPrice || highestListPrice !== highestDiscountPrice;

  const fmt = (price: number) => formatPrice(culture, currency, price, minimumFractionDigits);

  let priceDisplay: React.ReactNode;
  if (showComparison) {
    const listWrapperStyle: React.CSSProperties | undefined = splitInMultipleLines
      ? { display: "block" }
      : undefined;
    priceDisplay = (
      <Span className="comparative-pricing">
        <s><Span className="list-price-wrapper" aria-hidden="true" style={listWrapperStyle}>
          <Span className="swan-list-price">{fmt(lowestListPrice)}</Span>
          {" — "}
          <Span className="swan-list-price">{fmt(highestListPrice)}</Span>
        </Span></s>{" "}
        <Span className="swan-discount-price">
          {fmt(lowestDiscountPrice)} — {fmt(highestDiscountPrice)}
        </Span>
      </Span>
    );
  } else {
    priceDisplay = (
      <Span className="swan-list-price">
        {fmt(lowestListPrice)} — {fmt(highestListPrice)}
      </Span>
    );
  }

  return (
    <Span className={["swan-pricing", wrapperClass].filter(Boolean).join(" ")}>
      {priceDisplay}
      {!hideVatMessage && (
        <>
          {" "}
          <VatMessage
            locale={culture}
            vatInc={vatInc}
            hideShippingMessageInVatMessage={hideShippingMessageInVatMessage}
          />
        </>
      )}
    </Span>
  );
};

export default LegacyRangePrice;
